import { Icon } from '@ps/isp-web-component-library';
import { BetBuilder } from '@ps/isp-web-component-library/icons/BetBuilder';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import { TXTWCL_Bet_Builder } from './BetBuilderIcon.messages.json';
import styles from './BetBuilderIcon.scss';

const BetBuilderIcon: React.FC = () => {
  const { formatMessage } = useRegulatoryIntl();
  return (
    <div className={styles.iconContainer}>
      <div className={styles.background} />
      <Icon
        icon={BetBuilder}
        className={styles.icon}
        label={formatMessage(TXTWCL_Bet_Builder)}
        size="xs"
      />
    </div>
  );
};

export default BetBuilderIcon;
